import React from 'react';

import { Divider, Skeleton } from '@mui/material';

import styles from '../RoleForm.module.scss';

const PermissionSkeletonItem: React.FC = () => (
  <div className={styles.permission}>
    <Skeleton variant="text" width="60%" height={24} />
    <Divider className={styles.divider} />
  </div>
);

export default PermissionSkeletonItem;
